/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { AssistantStep } from '@/types';
import { Steps } from '@/enums';

const ASSISTANT_STEPS: Record<Steps, AssistantStep> = {
  [Steps.TypeDeclaration]: {
    title: 'Type de déclaration',
    dataTestId: 'assistant-step-type-declaration',
  },
  [Steps.SelectionPACS]: {
    title: 'Sélection du projet',
    dataTestId: 'assistant-step-selection-pacs',
  },
  [Steps.PACS]: {
    title: 'PACS',
    dataTestId: 'assistant-step-pacs',
  },
  [Steps.Partenaire1]: {
    title: 'Partenaire 1',
    dataTestId: 'assistant-step-partenaire1',
  },
  [Steps.ParentsPartenaire1]: {
    title: 'Parents Partenaire 1',
    dataTestId: 'assistant-step-parents-partenaire1',
  },
  [Steps.Partenaire2]: {
    title: 'Partenaire 2',
    dataTestId: 'assistant-step-partenaire2',
  },
  [Steps.ParentsPartenaire2]: {
    title: 'Parents Partenaire 2',
    dataTestId: 'assistant-step-parents-partenaire2',
  },
  [Steps.DeclarationConvention]: {
    title: 'Déclaration et convention',
    dataTestId: 'assistant-step-declaration-convention',
  },
};

export default ASSISTANT_STEPS;
